export default "__VITE_ASSET__379cdca8__"